import { Action } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { useState } from "react";
import useNotification from "../../notification/useNotification";
import { IAssignDevicesPayload } from "../../../common/types/devicesTypes";
import { assignDevices } from "./assignDevicesSlice";
import { useSpinner } from "../../../customHooks";
import React from "react";
import { fetchDeviceData } from "../../../pages/deviceManagement/deviceSlice";
import { Status } from "../../../common/constants";
import { IGroupAlerts, ISelectGroupState } from "../../../common/types/alertsTypes";
import { isSuccessResponse } from "../../../common/utils";
import { ISuccsessResponse } from "../../../common/types/uiTypes";
import { AxiosError } from "axios";
import { ICustomHook, IInitialSliceState, ITreeNode } from "../../../common/types/commonTypes";
import { IAssignDevice } from "../../../common/types/devicesTypes";
import { getAllNodeValues } from "../../treeView/util";

interface IAssignDevicesResponseState {
  assignDevices: IInitialSliceState;
}

export const useAssignDevices = (
  devices?: IAssignDevice[],
  setDeviceArray?: React.Dispatch<React.SetStateAction<IAssignDevice[]>>,
  setSelectedRows?: React.Dispatch<React.SetStateAction<[]>>,
  handleClose?: () => void,
  setAssignSuccessfully?: React.Dispatch<React.SetStateAction<boolean>>
): ICustomHook => {
  const dispatch: ThunkDispatch<IAssignDevicesResponseState, undefined, Action> =
    useDispatch();

  const createSelectGroupState: ISelectGroupState = {
    groups: [],
    checked: [],
    selectAllChecked: false,
  };

  const [parentOrg, setParentOrg] = useState<string[]>();
  const [isAnyDeviceSelected, setIsAnyDeviceSelected] =
    useState<boolean>(false);
  const [selectGroupState, setSelectGroupState] = useState<ISelectGroupState>(createSelectGroupState);
  const [selectedGroups, setSelectedGroups] = useState<IGroupAlerts[]>(selectGroupState?.groups);

  const handleDataFromTreeView = (selectedGroup) => {
    const groups: IGroupAlerts[] = getAllValuesWithLabels(selectedGroup);
    setSelectedGroups(groups);
    const allNodeValues: string[] = getAllNodeValues(
      selectedGroup,
      selectGroupState.selectAllChecked
    );
    setSelectGroupState({
      ...selectGroupState,
      groups: groups,
      checked: allNodeValues,
    });
  };

  const getAllValuesWithLabels = (nodes: ITreeNode[]) => {
    let result: IGroupAlerts[] = [];
    function traverse(node) {
      result.push({
        id: node.value || node.id,
        displayName: node.label || node.displayName,
      });
      if (selectGroupState?.selectAllChecked) {
        if (node.children && node.children.length > 0) {
          for (const child of node.children) {
            traverse(child);
          }
        }
      }
    }
    for (const node of nodes) {
      traverse(node);
    }
    return result;
  };


  React.useEffect(() => {
    devices?.length > 0
      ? setIsAnyDeviceSelected(true)
      : setIsAnyDeviceSelected(false);
  }, [devices?.length]);

  const getPayload = (): IAssignDevicesPayload => {
    const seletedGroup = selectedGroups.reduce((acc, curr) => {
      return [...acc, curr?.id];
    }, []);
    const assignDevicesPayload: IAssignDevicesPayload = {
      deviceDetails: devices,
      selectedGroupIds: seletedGroup,
    };
    return assignDevicesPayload;
  };

  const { showSuccessNotification, showWarningNotification } =
    useNotification();

  const handleAssignButtonClick = () => {
    const assignDevicesPayload = getPayload();
    dispatch(assignDevices(assignDevicesPayload)).then((response) => {
      const assignDevicesResponse = response.payload as
        | ISuccsessResponse
        | AxiosError;
      if (isSuccessResponse(assignDevicesResponse)) {
        setAssignSuccessfully(true);
        showSuccessNotification(assignDevicesResponse.message);
      } else {
        showWarningNotification(assignDevicesResponse.response.data.message);
      }
    });
    handleClose();
    setDeviceArray([]);
    setSelectedRows([]);
    setSelectGroupState(createSelectGroupState);
  };

  const closeAssignDevice = () => {
    setSelectGroupState(createSelectGroupState);
    handleClose();
  }

  return {
    handleAssignButtonClick,
    handleDataFromTreeView,
    isAnyDeviceSelected,
    selectGroupState,
    setSelectGroupState,
    closeAssignDevice
  };
};
